module.exports = __webpack_public_path__ + "img/4-4.f3c38c35.svg";